import { css } from "@emotion/react";
import Mixin from "../../../util/mixin";

export class BoxShadow extends Mixin {
  style({$}, [...shadow]) {
    if ($.enableShadows) {
      const result = shadow.filter(x => x !== "none");

      return result.length > 0 ?
        css`box-shadow: ${result};` :
        css``
      ;
    }
  }
}